var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCardView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 163,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m137.79,14.65c0,0 -23.91,31.35 -62.14,12.64c-38.23,-18.65 -76.45,31.94 -43.56,62.7c32.94,30.82 0.7,47.73 23.07,66.58c25.4,21.47 47.53,-22.05 67.7,-12.16c44.54,21.85 77.53,13.18 70.09,-12.12c-13.05,-44.38 -29.76,-47.29 -16.98,-70.4c12.77,-23.01 -15.35,-71.03 -38.18,-47.24z",
    fill: "#F1F3F3",
    id: "svg_1",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.51,84.09l-76.47,0c-3.13,0 -5.65,-2.52 -5.65,-5.65l0,-34.2c0,-3.13 2.52,-5.65 5.65,-5.65l76.47,0c3.13,0 5.65,2.52 5.65,5.65l0,34.2c0,3.13 -2.52,5.65 -5.65,5.65z",
    fill: "#eb672d",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.42,80.4l-76.24,0c-1.12,0 -2.06,-0.93 -2.06,-2.06l0,-33.96c0,-1.12 0.94,-2.05 2.06,-2.05l76.24,0c1.12,0 2.05,0.93 2.05,2.05l0,33.96c0,1.13 -0.93,2.06 -2.05,2.06z",
    fill: "#e59572",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.93,126.27l-76.47,0c-3.13,0 -5.66,-2.52 -5.66,-5.65l0,-34.19c0,-3.13 2.53,-5.66 5.66,-5.66l76.47,0c3.13,0 5.65,2.53 5.65,5.66l0,34.19c-0.05,3.13 -2.57,5.65 -5.65,5.65z",
    fill: "#eb672d",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.78,122.53l-76.23,0c-1.12,0 -2.06,-0.93 -2.06,-2.05l0,-33.96c0,-1.12 0.94,-2.06 2.06,-2.06l76.23,0c1.13,0 2.06,0.94 2.06,2.06l0,33.96c0,1.17 -0.93,2.05 -2.06,2.05z",
    fill: "#e59572",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.91,49.85c0,-1.17 0.93,-2.1 2.1,-2.1l34.15,0c1.16,0 2.1,0.93 2.1,2.1c0,1.17 -0.94,2.1 -2.1,2.1l-34.15,0c-1.22,-0.05 -2.1,-0.98 -2.1,-2.1z",
    fill: "#eb672d",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.91,69.75c0,-1.17 0.93,-2.1 2.1,-2.1l34.15,0c1.16,0 2.1,0.93 2.1,2.1c0,1.17 -0.94,2.1 -2.1,2.1l-34.15,0c-1.22,0 -2.1,-0.93 -2.1,-2.1z",
    fill: "#eb672d",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.76,93.11c0,-1.17 0.94,-2.11 2.11,-2.11l10.32,0c1.17,0 2.1,0.94 2.1,2.11c0,1.16 -0.93,2.1 -2.1,2.1l-10.37,0c-1.12,0 -2.06,-0.94 -2.06,-2.1z",
    fill: "#eb672d",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.28,107.59l-85.9,0c-3.13,0 -5.65,-2.53 -5.65,-5.65l0,-39.2c0,-3.13 2.52,-5.65 5.65,-5.65l85.9,0c3.13,0 5.66,2.52 5.66,5.65l0,39.2c0,3.12 -2.53,5.65 -5.66,5.65z",
    fill: "#eb672d",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.67,114.92c0,-1.17 0.93,-2.1 2.1,-2.1l55.12,0c1.17,0 2.11,0.93 2.11,2.1c0,1.17 -0.94,2.1 -2.11,2.1l-55.12,0c-1.17,0 -2.1,-0.93 -2.1,-2.1z",
    fill: "#eb672d",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.52,147.99c2.21,0 4,-1.79 4,-4c0,-2.21 -1.79,-4 -4,-4c-2.21,0 -4,1.79 -4,4c0,2.21 1.79,4 4,4z",
    fill: "#ffe2d6",
    id: "svg_11",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.32,0.75c1.5,0 2.68,1.21 2.68,2.68l0,18.01c0,1.49 -1.21,2.68 -2.68,2.68c-1.49,0 -2.68,-1.21 -2.68,-2.68l0,-18.01c-0.02,-1.47 1.19,-2.68 2.68,-2.68z",
    fill: "#ffe2d6",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.5,37.33c0,-1.5 1.21,-2.68 2.68,-2.68l18.01,0c1.49,0 2.68,1.21 2.68,2.68c0,1.49 -1.21,2.68 -2.68,2.68l-18.01,0c-1.47,0 -2.68,-1.22 -2.68,-2.68z",
    fill: "#ffe2d6",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.39,9.58c1.01,-1.07 2.7,-1.12 3.8,-0.11l13.11,12.26c1.07,1.02 1.13,2.71 0.11,3.81c-1.01,1.07 -2.7,1.13 -3.8,0.11l-13.11,-12.26c-1.07,-1.02 -1.13,-2.71 -0.11,-3.81z",
    fill: "#ffe2d6",
    id: "svg_14",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.22,144.11l3.68,-3.72c1.47,-1.48 1.47,-3.85 0,-5.28c-1.46,-1.48 -3.8,-1.48 -5.22,0l-3.68,3.72l-3.68,-3.72c-1.46,-1.48 -3.8,-1.48 -5.22,0c-1.47,1.48 -1.47,3.84 0,5.28l3.68,3.72l-3.47,3.5c-1.47,1.48 -1.47,3.85 0,5.28c1.46,1.48 3.8,1.48 5.22,0l3.47,-3.51l3.47,3.51c1.46,1.48 3.8,1.48 5.22,0c1.47,-1.48 1.47,-3.84 0,-5.28l-3.47,-3.5z",
    fill: "#ffe2d6",
    id: "svg_15",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.67,65.03l2.05,-2.05c1.64,-1.64 1.64,-4.25 0,-5.84c-1.63,-1.64 -4.25,-1.64 -5.84,0l-2.05,2.05l-2.06,-2.05c-1.63,-1.64 -4.25,-1.64 -5.84,0c-1.63,1.63 -1.63,4.25 0,5.84l2.06,2.05l-2.06,2.06c-1.63,1.63 -1.63,4.25 0,5.84c1.64,1.63 4.25,1.63 5.84,0l2.06,-2.06l2.05,2.06c1.64,1.63 4.25,1.63 5.84,0c1.64,-1.64 1.64,-4.25 0,-5.84l-2.05,-2.06z",
    fill: "#ffe2d6",
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.77,103.48l-84.88,0c-1.12,0 -2.05,-0.94 -2.05,-2.06l0,-38.16c0,-1.12 0.93,-2.06 2.05,-2.06l84.93,0c1.12,0 2.05,0.94 2.05,2.06l0,38.16c-0.04,1.17 -0.98,2.06 -2.1,2.06z",
    fill: "#FCFDFD",
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.92,77.18c1.52,0 2.76,-1.24 2.76,-2.76c0,-1.52 -1.24,-2.75 -2.76,-2.75c-1.52,0 -2.75,1.23 -2.75,2.75c0,1.52 1.23,2.76 2.75,2.76z",
    fill: "#eb672d",
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.53,77.18c1.52,0 2.75,-1.24 2.75,-2.76c0,-1.52 -1.23,-2.76 -2.75,-2.76c-1.53,0 -2.76,1.24 -2.76,2.76c0,1.52 1.23,2.76 2.76,2.76z",
    fill: "#eb672d",
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.83,91.19l-6.63,0c-1.54,0 -2.76,-1.21 -2.76,-2.76c0,-1.54 1.22,-2.75 2.76,-2.75l6.63,0c1.54,0 2.76,1.21 2.76,2.75c0,1.5 -1.26,2.76 -2.76,2.76z",
    fill: "#eb672d",
    id: "svg_20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8,110.08c-3.32,0 -6,2.67 -6,6c0,3.32 2.68,6 6,6c3.33,0 6,-2.68 6,-6c0,-3.33 -2.67,-6 -6,-6zm0,8.17c-1.18,0 -2.18,-0.95 -2.18,-2.17c0,-1.23 0.96,-2.18 2.18,-2.18c1.22,0 2.18,0.95 2.18,2.18c0,1.22 -0.96,2.17 -2.18,2.17z",
    fill: "#ffe2d6",
    id: "svg_21",
    transform: "matrix(1 0 0 1 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCardView);
export default __webpack_public_path__ + "static/media/emptyCardView.9eb29fb7b822dc7fbd1c84b4cb875bd6.svg";
export { ForwardRef as ReactComponent };